import { AnalyticsService } from "../services/analytics/analytics.service";

export enum SearchToolbarDateFunction {
    VaDates,
    CsDates,
    SpDates,
    VaDatesPromo
}

export enum SearchToolbarSection {
    Dates,
    CardModes,
    Clusterlist,
    GroupTypes,
    Groups,
    Areas,
    Stores
}

export enum SearchToolbarFilterWindow {
    Month = "MESE",
    Week = "SETTIMANA",
    Three = '3',
    Five = '5',
    Six = '6',
    Twenty = '20',
    TwentyFive = '25',
    TwentyNine = '29',
    ThirtyTwo = '32',
    ThirtyFive = '35',
    FortySeven = '47',
    FiftyOne = '51',
    FiftyThree = '53',
    None = ''
}

export enum SearchToolbarFilterGrouping {
    All = "ALL",
    None = ''
}

export class SearchToolbarFactoryParameters {
    public svcAnalytics: AnalyticsService;
    public dateFunctionType: SearchToolbarDateFunction = SearchToolbarDateFunction.VaDates;
    public raggruppamento: SearchToolbarFilterGrouping = null;
    public finestra: SearchToolbarFilterWindow = null;
    public disabledSections: SearchToolbarSection[] = [];
}



// WEBPACK FOOTER //
// ./src/app/models/search-toolbar-factory-parameters.model.ts